module.exports = __webpack_public_path__ + "img/FullCover_Chi.fbdd1b92.jpg";